"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingMockStates = void 0;
var OnboardingMockStates;
(function (OnboardingMockStates) {
    // Happy path - Classic
    OnboardingMockStates["ONBOARDING"] = "onboarding";
    OnboardingMockStates["CREDIT_CARD_ONBOARDING"] = "creditCardOnboarding";
    OnboardingMockStates["MLA_ONBOARDING"] = "mlaOnboarding";
    OnboardingMockStates["CREDIT_BUILDER_ONBOARDING"] = "creditBuilderOnboarding";
    OnboardingMockStates["INCOME_VERIFICATION_ONBOARDING"] = "incomeVerificationOnboarding";
    OnboardingMockStates["DOCUMENT_VERIFICATION_ONBOARDING"] = "documentVerificationOnboarding";
    // Happy path - Flex Anywhere
    OnboardingMockStates["FLEX_ANYWHERE_ONBOARDING"] = "flexAnywhereOnboarding";
    OnboardingMockStates["SLC_CLASSIC_FLEX_ANYWHERE_ONBOARDING"] = "slcClassicflexAnywhereOnboarding";
    OnboardingMockStates["SLC_ENABLED"] = "slcEnabled";
    OnboardingMockStates["SLC_CLASSIC_ENABLED"] = "slcClassicEnabled";
    OnboardingMockStates["SLC_SIMPLIFIED_PAYMENTS_ENABLED"] = "slcSimplifiedPaymentsEnabled";
    OnboardingMockStates["CREDIT_BUILDER_ENABLED"] = "creditBuilderEnabled";
    // Sad path
    OnboardingMockStates["DUPLICATE_SSN"] = "duplicateSSN";
    OnboardingMockStates["SETUP_CARD_CAPITAL_ONE_FAILURE_ONBOARDING"] = "setupCardCapitalOneFailureOnboarding";
    OnboardingMockStates["SETUP_CARD_V2_CARD_LINKAGE_FAIL_ONBOARDING"] = "setupCardV2CardLinkageFailOnboarding";
    // Resume onboarding
    OnboardingMockStates["RESUME_ONBOARDING"] = "resumeOnboarding";
    OnboardingMockStates["RESUME_ONBOARDING_EPISODIC"] = "resumeOnboardingEpisodic";
    OnboardingMockStates["RESUME_ONBOARDING_CREDIT_BUILDER"] = "resumeOnboardingCreditBuilder";
    OnboardingMockStates["RESUME_ONBOARDING_INCOME_VERIFICATION"] = "resumeOnboardingIncomeVerification";
    OnboardingMockStates["RESUME_ONBOARDING_DOCUMENT_VERIFICATION"] = "resumeOnboardingDocumentVerification";
})(OnboardingMockStates || (exports.OnboardingMockStates = OnboardingMockStates = {}));
